import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AccountingService } from 'app/core/services/Accounting/accounting.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { Observable, Subject, concat, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-tax-code',
  templateUrl: './tax-code.component.html',
  styleUrls: ['./tax-code.component.scss']
})
export class TaxCodeComponent implements OnInit, OnChanges {
  @Input() value: string = '';
  @Output() codeSelected: EventEmitter<any> = new EventEmitter();
  @Output() dropdownStateChange: EventEmitter<boolean> = new EventEmitter();

  selectedCode: string;
  isDropdownOpened: boolean = false;
  listValue$: Observable<any[]> = new Observable<any[]>();
  preloadedValue: any = [];
  valueSubject$: Subject<string | null> = new Subject<string | null>();
  lookupLoading: boolean = false;
  pageSize: number = 1;

  constructor(
    private _dataCollectorService: DataCollectorService,
    private _accountingService: AccountingService
  ) { }

  onOptionSelected(option: any): void {
    this.codeSelected.emit(this.selectedCode);
  }

  setInitialListValue(term = ''): void {
    const paramObj = {
      'page': this.pageSize,
      'filter.keyword': term,
      'limit': ''
    };
    this._dataCollectorService.getData(this._accountingService.accountingUrl.taxCode, paramObj).subscribe((response: any) => {
        if(response?.data){
            this.preloadedValue = [...this.preloadedValue,...response.data];
            this.loadLookupValues();
        }
      });
  }

  setListValue(term = ''): any {
    if([null,undefined].includes(term)){
      this.lookupLoading = false;
      return of(null);
    }
    const paramObj = {
      'page': this.pageSize,
      'filter.keyword': term,
      'limit': ''
    };
    return this._dataCollectorService.getData(this._accountingService.accountingUrl.taxCode, paramObj)
    .pipe(
      map((response: any) => response?.data)
    );
  }

  ngOnInit(): void {
    this.selectedCode = this.value;
    this.setInitialListValue();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if('value' in changes){
      this.value = changes.value.currentValue;
      this.selectedCode = this.value;
    }
  }

  onOpenDropdown(): void{
    this.isDropdownOpened = true;
    this.dropdownStateChange.emit(this.isDropdownOpened);
  }

  onCloseDropdown(): void{
    this.isDropdownOpened = false;
    this.dropdownStateChange.emit(this.isDropdownOpened);
  }

  onTaxCodeClear(): void{
    this.preloadedValue = [];
    this.setInitialListValue();
  }

  private loadLookupValues(): any {
    this.lookupLoading = false;
    this.listValue$ = concat(
      of(this.preloadedValue),
      this.valueSubject$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => (this.lookupLoading = true)),
        tap(() => (this.pageSize = 1)),
        switchMap((term: any) =>
          this.setListValue(term).pipe(
            catchError(() => of(this.preloadedValue)),
            tap(() => (this.lookupLoading = false))
          )
        )
      )
    );
  }

}
